export const romanNumeralPattern = /^(?=.+)M{0,3}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/

const symbols: Record<string, string> = {
  I: 'Ⅰ', II: 'Ⅱ', III: 'Ⅲ', IV: 'Ⅳ', V: 'Ⅴ', VI: 'Ⅵ',
  VII: 'Ⅶ', VIII: 'Ⅷ', IX: 'Ⅸ', X: 'Ⅹ', XI: 'Ⅺ', XII: 'Ⅻ',
  L: 'Ⅼ', C: 'Ⅽ', D: 'Ⅾ', M: 'Ⅿ',
}

/** Compare old ASCII names with Unicode numerals without rewriting name bodies. */
export function normalizeRomanNumerals(value: string): string {
  return value.replace(/[\u2160-\u217f]/g, symbol => symbol.normalize('NFKC').toUpperCase())
}

/** Only call for a numeral, never an entire map name or an OCR digit guess. */
export function formatRomanNumeral(value: string): string {
  const ascii = normalizeRomanNumerals(value)
  if (!romanNumeralPattern.test(ascii)) return value
  return symbols[ascii] ?? ascii.replace(/IX|VIII|VII|VI|IV|III|II|[IVXLCDM]/g, part => symbols[part]!)
}
